import { useQuery } from "react-query";
import { USE_QUERY_OPTIONS } from "../../dynamicForm/lib/constants";
import { useAxiosInstance } from "../../dynamicForm/hooks/useAxiosInstance";

export const useWellType = (wellId) => {
  const axiosInstance = useAxiosInstance();

  return useQuery(
    ["well-type", wellId],
    async () => {
      if (!wellId) return null;
      const { data } = await axiosInstance.get(
        `/well-registration/${wellId}/type`
      );
      return data;
    },
    {
      ...USE_QUERY_OPTIONS,
      enabled: !!wellId,
    }
  );
};
